// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as SuspensionStatus from "../../../../app/suspension/entity/SuspensionStatus.bs.js";
import * as TableComponent$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/table/TableComponent.bs.js";
import * as OptionTypeUtils$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/utils/OptionTypeUtils.bs.js";

function getTableColumnsSchema(param) {
  return {
          hd: {
            column: {
              TAG: /* Text */0,
              _0: "Event Time"
            },
            accessor: (function (suspension_record) {
                return {
                        TAG: /* Text */0,
                        _0: suspension_record.event_time
                      };
              })
          },
          tl: {
            hd: {
              column: {
                TAG: /* Text */0,
                _0: "Expires At"
              },
              accessor: (function (suspension_record) {
                  return {
                          TAG: /* Text */0,
                          _0: OptionTypeUtils$Catalyst.getStringFrmOptionalType(suspension_record.expiry_time)
                        };
                })
            },
            tl: {
              hd: {
                column: {
                  TAG: /* Text */0,
                  _0: "Reason"
                },
                accessor: (function (suspension_record) {
                    return {
                            TAG: /* Text */0,
                            _0: suspension_record.reason
                          };
                  })
              },
              tl: {
                hd: {
                  column: {
                    TAG: /* Text */0,
                    _0: "Comment"
                  },
                  accessor: (function (suspension_record) {
                      return {
                              TAG: /* Text */0,
                              _0: OptionTypeUtils$Catalyst.getStringFrmOptionalType(suspension_record.comment)
                            };
                    })
                },
                tl: {
                  hd: {
                    column: {
                      TAG: /* Text */0,
                      _0: "Event Type"
                    },
                    accessor: (function (suspension_record) {
                        return {
                                TAG: /* Text */0,
                                _0: SuspensionStatus.toString(suspension_record.status)
                              };
                      })
                  },
                  tl: {
                    hd: {
                      column: {
                        TAG: /* Text */0,
                        _0: "Event Mode"
                      },
                      accessor: (function (suspension_record) {
                          return {
                                  TAG: /* Text */0,
                                  _0: suspension_record.event_mode
                                };
                        })
                    },
                    tl: {
                      hd: {
                        column: {
                          TAG: /* Text */0,
                          _0: "Suspended / Un-suspended By"
                        },
                        accessor: (function (suspension_record) {
                            return {
                                    TAG: /* Text */0,
                                    _0: OptionTypeUtils$Catalyst.getStringFrmOptionalType(suspension_record.administrator)
                                  };
                          })
                      },
                      tl: /* [] */0
                    }
                  }
                }
              }
            }
          }
        };
}

function DriverSuspensionListTable(Props) {
  var tableData = Props.tableData;
  return React.createElement("div", {
              className: "table-wrapper"
            }, React.createElement(TableComponent$Catalyst.make, {
                  columns: getTableColumnsSchema(undefined),
                  rowData: tableData,
                  className: "customTable"
                }));
}

var make = DriverSuspensionListTable;

export {
  getTableColumnsSchema ,
  make ,
  
}
/* react Not a pure module */
